import styled from 'styled-components';

import { FC, HTMLAttributes } from 'react';
import CollapseArrow from '../CollapseArrow';
import Collapsable from '../Collapsable';
import Link from '../../navigation/Link';

export const StyledCollapsable = styled(Collapsable)`
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const StyledButton = styled(Link.StyledLink as FC<HTMLAttributes<HTMLAnchorElement>>)`
  text-align: left;
`;

export const StyledContent = styled.div`
  padding: 16px 0 0 0;
`;

export const StyledArrow = styled(CollapseArrow)`
  position: relative;
  flex-shrink: 0;
  top: 0;
  margin-right: 4px;
  margin-bottom: -6px;
`;
